// extracted by mini-css-extract-plugin
module.exports = {"root":"CarouselCounter_root__aPcuU","divider":"CarouselCounter_divider__RgjFI","total":"CarouselCounter_total__0yQgs","reveal-media":"CarouselCounter_reveal-media__H20aW"};